import type React from "react";
import { useToolbarStateCtx } from "../../components/cms/edit-overlay/ToolbarStateProvider";
import { ReactComponent as ContentfulIconSvg } from "../../components/cms/SiteMapComponent/contentful-icon.svg";
import { css } from "@emotion/react";
import { CSS_COLORS } from "../../styles/styles-css-variables";
import { useContentfulLink } from "../../components/useContentfulLink";
import { FONTS, fontSize } from "../../styles/fonts";

export const ContentfulEntryEditorLink: React.FC<{ children: React.ReactNode; entryId: string }> = ({
  children,
  entryId,
}) => {
  const ctx = useToolbarStateCtx();
  const contentfulLink = useContentfulLink();

  if (!ctx.state?.componentLinks) {
    return <>{children}</>;
  }

  const entryLink = contentfulLink(entryId);

  return (
    <div className="u-relative js-contentful-entry-editor-link">
      {children}

      <span
        onClick={() => window.open(entryLink, "_blank")}
        className="u-absolute u-left-0 u-top-0"
        css={css`
          background: ${CSS_COLORS.YellowCustom};

          transition: transform 0.2s linear;
          &:hover {
            transform: scale(1.1);
          }

          padding: 4px;
          border-radius: 100%;

          width: 24px;
          height: 24px;

          display: flex;
          align-items: center;
          justify-content: center;

          cursor: pointer;
        `}
      >
        <ContentfulIconSvg title={`Entry ${entryId} in Contentful`} />
        <span
          className="u-absolute"
          css={[
            fontSize.x2s,
            css`
              bottom: -14px;
              left: -2px;
              position: absolute;
            `,
          ]}
        >
          Entry
        </span>
      </span>
    </div>
  );
};
